import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// Lista o catálogo de tipos de carga do cliente da sessão.
// AJUSTE BACKEND AQUI: a listagem precisa devolver os tipos natos (catálogo padrão, sem idCliente)
// somados aos do cliente informado — hoje o filtro por idCliente esconderia os natos.
export const getTipoCarga = async (idCliente) => {
    const effectiveClientId = idCliente || getSessionClientId();
    return await request(`/api/tipoCarga?idCliente=${effectiveClientId}`);
};

// Cria um tipo de carga vinculado ao cliente da sessão.
export const createTipoCarga = async (tipoCargaData) => {
    return await request("/api/tipoCarga", {
        method: 'POST',
        body: JSON.stringify({ ...tipoCargaData, idCliente: getSessionClientId() })
    });
};

// Atualiza um tipo de carga por id.
export const updateTipoCarga = async (idTipoCarga, tipoCargaData) => {
    return await request(`/api/tipoCarga/${idTipoCarga}`, {
        method: 'PUT',
        body: JSON.stringify({ ...tipoCargaData, idCliente: getSessionClientId() })
    });
};
// Exclui um tipo de carga por id.
export const deleteTipoCarga = async (idTipoCarga) => {
    return await request(`/api/tipoCarga/${idTipoCarga}`, {
        method: 'DELETE'
    })
}
